/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react'
import {
  ModernModalBackdrop,
  ModernVerticalModal,
  ModalFieldGroup,
  ModalLabel,
  ModalInput,
  ModalSelect,
  SubmitButton,
} from '../../../styles/Modal'
import { IoCloseCircleSharp, IoColorWandOutline } from 'react-icons/io5'
import ModalLayoutAssistant from '../ModalLayoutAssistant'
import api from '../../../services/axios'
import { toast } from 'react-toastify'

interface ModalProps {
  data: UsersUpdatedProps
  setData: (data: UsersUpdatedProps) => void
  loading: boolean
  handleClick: () => void
  setCloseModal: () => void
  users: any[]
  handlePhoneChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export interface UsersUpdatedProps {
  id: number
  name: string
  cnpj?: string
  response: string
  gestor_id?: number
  fantasy_name: string
  status?: number
  response_email: string
  response_telefone: string
  cod_dist: string
  visualizador?: number
  conv_familia?: string
  campos_vendas?: any[]
  campos_estoque?: any[]
  campos_produtos?: any[]
  campos_frocavenda?: any[]
  campos_clientes?: any[]
}

function ModalDistEdit({
  data,
  setData,
  loading,
  handleClick,
  users,
  handlePhoneChange,
  setCloseModal,
}: ModalProps) {
  const [jsonError, setJsonError] = useState<string | null>(null)
  const [openAssistant, setOpenAssistant] = useState<boolean>(false)
  const [layoutsCadastrados, setLayoutsCadastrados] = useState<Record<string, any[]>>({})

  const handleChange = (field: keyof UsersUpdatedProps, value: any) => {
    setData({ ...data, [field]: value })
  }

  const handleJsonChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value
    handleChange('conv_familia', value)

    if (!value.trim()) {
      setJsonError(null)
      return
    }

    try {
      JSON.parse(value)
      setJsonError(null)
    } catch (error) {
      setJsonError('⚠️ JSON inválido: verifique vírgulas, aspas ou chaves.')
    }
  }

  const formatJson = () => {
    if (!data.conv_familia || !data.conv_familia.trim()) return
    try {
      const parsed = JSON.parse(data.conv_familia)
      const formatted = JSON.stringify(parsed, null, 2)
      handleChange('conv_familia', formatted)
      setJsonError(null)
    } catch (error) {
      setJsonError('⚠️ Não é possível formatar: O código atual contém erros.')
    }
  }

  useEffect(() => {
    if (data.conv_familia) {
      try {
        const parsed = JSON.parse(data.conv_familia)
        handleChange('conv_familia', JSON.stringify(parsed, null, 2))
      } catch (e) {
        // Ignora erros iniciais de formatação
      }
    }
  }, [])

  // Carrega os layouts salvos no banco para este distribuidor
  useEffect(() => {
    if (data.id) {
      api
        .get(`/layout/posicao/${data.id}`)
        .then((res) => {
          const layouts = res.data?.layout?.layouts || {}
          setLayoutsCadastrados(layouts)
        })
        .catch((err) => {
          console.warn('Layouts não carregados para o distribuidor:', err)
        })
    }
  }, [data.id])

  const visualizadores = users.filter(
    (u) => u.role?.toLowerCase() === 'visualizador' && u.status === 1,
  )

  return (
    <>
      <ModernModalBackdrop>
        <ModernVerticalModal>
        <div className="header">
          <h3>Editar Distribuidor</h3>
          <button className="btn-close" onClick={setCloseModal} type="button">
            <IoCloseCircleSharp />
          </button>
        </div>

        <div className="body">
          <p className="form-section-title">Dados Gerais</p>

          <ModalFieldGroup>
            <ModalLabel>Razão Social</ModalLabel>
            <ModalInput
              type="text"
              value={data.name}
              onChange={(e) => handleChange('name', e.target.value)}
              placeholder="Digite a razão social"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Nome Fantasia</ModalLabel>
            <ModalInput
              type="text"
              value={data.fantasy_name}
              onChange={(e) => handleChange('fantasy_name', e.target.value)}
              placeholder="Digite o nome fantasia"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>CNPJ</ModalLabel>
            <ModalInput
              type="text"
              value={data.cnpj || ''}
              onChange={(e) => handleChange('cnpj', e.target.value)}
              placeholder="00.000.000/0000-00"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Cód. Distribuidor</ModalLabel>
            <ModalInput
              type="text"
              value={data.cod_dist}
              onChange={(e) => handleChange('cod_dist', e.target.value)}
              placeholder="Código identificador do distribuidor"
            />
          </ModalFieldGroup>

          <p className="form-section-title">Contato Responsável</p>

          <ModalFieldGroup>
            <ModalLabel>Responsável (Nome)</ModalLabel>
            <ModalInput
              type="text"
              value={data.response}
              onChange={(e) => handleChange('response', e.target.value)}
              placeholder="Nome do contato responsável"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>E-mail de Retorno</ModalLabel>
            <ModalInput
              type="email"
              value={data.response_email}
              onChange={(e) => handleChange('response_email', e.target.value)}
              placeholder="Ex: retorno@distribuidora.com"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Telefone</ModalLabel>
            <ModalInput
              type="text"
              value={data.response_telefone}
              onChange={handlePhoneChange}
              maxLength={15}
              placeholder="(00) 00000-0000"
            />
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Status</ModalLabel>
            <ModalSelect
              value={data.status}
              onChange={(e) => handleChange('status', Number(e.target.value))}
            >
              <option value={1}>Ativo</option>
              <option value={0}>Inativo</option>
            </ModalSelect>
          </ModalFieldGroup>

          <ModalFieldGroup>
            <ModalLabel>Visualizador Responsável</ModalLabel>
            <ModalSelect
              value={data.visualizador || ''}
              onChange={(e) => {
                const val = e.target.value
                handleChange('visualizador', val === '' ? undefined : Number(val))
              }}
            >
              <option value="">Selecione um visualizador (Opcional)</option>
              {visualizadores.map((user) => (
                <option key={user.id} value={user.id}>
                  {user.name} ({user.nickname})
                </option>
              ))}
            </ModalSelect>
          </ModalFieldGroup>

          <p className="form-section-title">Parâmetros de Conversão</p>

          <ModalFieldGroup>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <ModalLabel>Conv. Família (JSON)</ModalLabel>
              <button
                type="button"
                onClick={formatJson}
                style={{
                  background: 'rgba(255, 255, 255, 0.08)',
                  color: '#ffffff',
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  padding: '4px 10px',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '11px',
                  fontWeight: 600,
                  fontFamily: 'Montserrat',
                }}
              >
                ✨ Formatar JSON
              </button>
            </div>
            <textarea
              value={data.conv_familia || ''}
              onChange={handleJsonChange}
              rows={6}
              placeholder='Ex: {"chave": "valor"}'
              style={{
                width: '100%',
                fontFamily: 'monospace',
                padding: '12px',
                borderRadius: '12px',
                border: jsonError ? '1px solid #ef4444' : '1px solid rgba(255, 255, 255, 0.1)',
                backgroundColor: 'rgba(255, 255, 255, 0.04)',
                color: '#ffffff',
                resize: 'vertical',
                outline: 'none',
                fontSize: '13px',
              }}
            />
            {jsonError && (
              <span style={{ color: '#f87171', fontSize: '11px', fontWeight: 'bold', marginTop: '2px' }}>
                {jsonError}
              </span>
            )}
          </ModalFieldGroup>

          <p className="form-section-title">Layouts TXT do Distribuidor</p>

          <ModalFieldGroup>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <button
                type="button"
                onClick={() => setOpenAssistant(true)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  background: 'linear-gradient(135deg, #0284c7, #0369a1)',
                  border: '1px solid rgba(56, 189, 248, 0.4)',
                  color: '#ffffff',
                  fontSize: '12px',
                  fontWeight: 700,
                  padding: '10px 14px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  width: '100%',
                  boxShadow: '0 4px 12px rgba(2, 132, 199, 0.25)',
                  transition: 'all 0.2s',
                }}
              >
                <IoColorWandOutline style={{ fontSize: '18px', color: '#38bdf8' }} />
                <span>🪄 Assistente de Layout TXT (Editar / Visualizar Layouts)</span>
              </button>

              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                <span
                  style={{
                    fontSize: '10px',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    background:
                      (layoutsCadastrados.vendas?.length || 0) > 0
                        ? 'rgba(34, 197, 94, 0.15)'
                        : 'rgba(255, 255, 255, 0.05)',
                    color: (layoutsCadastrados.vendas?.length || 0) > 0 ? '#4ade80' : '#94a3b8',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                  }}
                >
                  Vendas:{' '}
                  {(layoutsCadastrados.vendas?.length || 0) > 0
                    ? `${layoutsCadastrados.vendas.length} campos`
                    : 'Padrão'}
                </span>
                <span
                  style={{
                    fontSize: '10px',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    background:
                      (layoutsCadastrados.estoque?.length || 0) > 0
                        ? 'rgba(34, 197, 94, 0.15)'
                        : 'rgba(255, 255, 255, 0.05)',
                    color: (layoutsCadastrados.estoque?.length || 0) > 0 ? '#4ade80' : '#94a3b8',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                  }}
                >
                  Estoque:{' '}
                  {(layoutsCadastrados.estoque?.length || 0) > 0
                    ? `${layoutsCadastrados.estoque.length} campos`
                    : 'Padrão'}
                </span>
                <span
                  style={{
                    fontSize: '10px',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    background:
                      (layoutsCadastrados.produtos?.length || 0) > 0
                        ? 'rgba(34, 197, 94, 0.15)'
                        : 'rgba(255, 255, 255, 0.05)',
                    color: (layoutsCadastrados.produtos?.length || 0) > 0 ? '#4ade80' : '#94a3b8',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                  }}
                >
                  Produtos:{' '}
                  {(layoutsCadastrados.produtos?.length || 0) > 0
                    ? `${layoutsCadastrados.produtos.length} campos`
                    : 'Padrão'}
                </span>
                <span
                  style={{
                    fontSize: '10px',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    background:
                      (layoutsCadastrados.forcavenda?.length || 0) > 0
                        ? 'rgba(34, 197, 94, 0.15)'
                        : 'rgba(255, 255, 255, 0.05)',
                    color: (layoutsCadastrados.forcavenda?.length || 0) > 0 ? '#4ade80' : '#94a3b8',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                  }}
                >
                  Força Vendas:{' '}
                  {(layoutsCadastrados.forcavenda?.length || 0) > 0
                    ? `${layoutsCadastrados.forcavenda.length} campos`
                    : 'Padrão'}
                </span>
                <span
                  style={{
                    fontSize: '10px',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    background:
                      (layoutsCadastrados.clientes?.length || 0) > 0
                        ? 'rgba(34, 197, 94, 0.15)'
                        : 'rgba(255, 255, 255, 0.05)',
                    color: (layoutsCadastrados.clientes?.length || 0) > 0 ? '#4ade80' : '#94a3b8',
                    border: '1px solid rgba(255, 255, 255, 0.08)',
                  }}
                >
                  Clientes:{' '}
                  {(layoutsCadastrados.clientes?.length || 0) > 0
                    ? `${layoutsCadastrados.clientes.length} campos`
                    : 'Padrão'}
                </span>
              </div>
            </div>
          </ModalFieldGroup>

          <SubmitButton
            type="button"
            onClick={handleClick}
            disabled={loading || jsonError !== null}
          >
            {loading ? 'Salvando...' : 'Salvar Alterações'}
          </SubmitButton>
        </div>
      </ModernVerticalModal>
    </ModernModalBackdrop>

    <ModalLayoutAssistant
      isOpen={openAssistant}
      onClose={() => setOpenAssistant(false)}
      distId={data.id}
      layoutsCadastrados={layoutsCadastrados}
      onApplyLayout={(tipo, campos) => {
        setLayoutsCadastrados((prev) => ({ ...prev, [tipo]: campos }))
        const chave =
          tipo === 'vendas'
            ? 'campos_vendas'
            : tipo === 'estoque'
            ? 'campos_estoque'
            : tipo === 'produtos'
            ? 'campos_produtos'
            : tipo === 'forcavenda'
            ? 'campos_frocavenda'
            : 'campos_clientes'
        setData({ ...data, [chave]: campos } as any)
      }}
    />
  </>
  )
}

export default ModalDistEdit
